export default __webpack_public_path__ + "static/media/icn-welcome-off.cb6c7e3b.svg";